// Theme presets + token → CSS variable conversion (hex → "h s% l%")

export function hexToHslString(hex) {
  if (!hex) return "0 0% 0%";
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.substring(0, 2), 16) / 255;
  const g = parseInt(h.substring(2, 4), 16) / 255;
  const b = parseInt(h.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue = 0, sat = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    sat = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hue = (b - r) / d + 2;
    else hue = (r - g) / d + 4;
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(sat * 100)}% ${Math.round(l * 100)}%`;
}

export function tokensToStyle(tokens) {
  const t = tokens || {};
  const bg = hexToHslString(t.background);
  const fg = hexToHslString(t.foreground);
  const card = hexToHslString(t.card);
  const cardFg = hexToHslString(t.cardForeground);
  const primary = hexToHslString(t.primary);
  const primaryFg = hexToHslString(t.primaryForeground);
  const muted = hexToHslString(t.muted);
  const mutedFg = hexToHslString(t.mutedForeground);
  const border = hexToHslString(t.border);
  return {
    "--background": bg, "--foreground": fg,
    "--card": card, "--card-foreground": cardFg,
    "--popover": card, "--popover-foreground": cardFg,
    "--primary": primary, "--primary-foreground": primaryFg,
    "--secondary": muted, "--secondary-foreground": fg,
    "--muted": muted, "--muted-foreground": mutedFg,
    "--accent": muted, "--accent-foreground": fg,
    "--destructive": "0 72% 51%", "--destructive-foreground": "0 0% 100%",
    "--border": border, "--input": border, "--ring": primary,
    "--radius": t.radius || "1rem",
  };
}

export const PRESETS = {
  midnight_noodle: {
    name: "Midnight Noodle", type: "dark",
    tokens: { background: "#0F0F11", foreground: "#F8F8F8", card: "#18181B", cardForeground: "#F8F8F8", primary: "#D4FF32", primaryForeground: "#000000", muted: "#27272A", mutedForeground: "#A1A1AA", border: "#27272A", radius: "1rem" },
  },
  warmindo_classic: {
    name: "Warmindo Classic", type: "light",
    tokens: { background: "#FDFBF7", foreground: "#1A1A1A", card: "#FFFFFF", cardForeground: "#1A1A1A", primary: "#E63946", primaryForeground: "#FFFFFF", muted: "#F3F1EC", mutedForeground: "#737373", border: "#E5E5E5", radius: "1rem" },
  },
  matcha_minimalist: {
    name: "Matcha Minimalist", type: "light",
    tokens: { background: "#F4F6F0", foreground: "#2C3B2E", card: "#FFFFFF", cardForeground: "#2C3B2E", primary: "#4A6650", primaryForeground: "#FFFFFF", muted: "#E9EBE4", mutedForeground: "#6B7A6D", border: "#DDE0D8", radius: "1.5rem" },
  },
  kopi_susu: {
    name: "Kopi Susu", type: "light",
    tokens: { background: "#F8F5F2", foreground: "#3E2723", card: "#FFFFFF", cardForeground: "#3E2723", primary: "#B5651D", primaryForeground: "#FFFFFF", muted: "#EFEBE6", mutedForeground: "#8D6E63", border: "#E7E0D8", radius: "0.75rem" },
  },
  spicy_brutalism: {
    name: "Spicy Brutalism", type: "light",
    tokens: { background: "#FFFFFF", foreground: "#000000", card: "#FFFFFF", cardForeground: "#000000", primary: "#FF3B30", primaryForeground: "#FFFFFF", muted: "#F4F4F5", mutedForeground: "#52525B", border: "#111111", radius: "0rem" },
  },
  ocean_breeze: {
    name: "Ocean Breeze", type: "light",
    tokens: { background: "#F0F4F8", foreground: "#102A43", card: "#FFFFFF", cardForeground: "#102A43", primary: "#00539C", primaryForeground: "#FFFFFF", muted: "#D9E2EC", mutedForeground: "#486581", border: "#D9E2EC", radius: "1.25rem" },
  },
  royal_purple: {
    name: "Royal Grape", type: "dark",
    tokens: { background: "#141019", foreground: "#F6F2FB", card: "#1F1826", cardForeground: "#F6F2FB", primary: "#C084FC", primaryForeground: "#1A0B2E", muted: "#2A2233", mutedForeground: "#A79BB5", border: "#2A2233", radius: "1.25rem" },
  },
  sunset_mango: {
    name: "Sunset Mango", type: "light",
    tokens: { background: "#FFF8F0", foreground: "#3D1F0F", card: "#FFFFFF", cardForeground: "#3D1F0F", primary: "#FF7A00", primaryForeground: "#FFFFFF", muted: "#FCEBDA", mutedForeground: "#9C6B45", border: "#F5E0CC", radius: "1.5rem" },
  },
};

export const TOKEN_FIELDS = [
  { key: "background", label: "Background" },
  { key: "foreground", label: "Teks" },
  { key: "card", label: "Kartu" },
  { key: "cardForeground", label: "Teks Kartu" },
  { key: "primary", label: "Warna Utama" },
  { key: "primaryForeground", label: "Teks Utama" },
  { key: "muted", label: "Sekunder" },
  { key: "mutedForeground", label: "Teks Redup" },
  { key: "border", label: "Garis Tepi" },
];
